import { DriverStatus } from '../enums';

export const DRIVER_STATUS_CHIP_CLASSES: Record<string, string> = {
    [DriverStatus.PENDING]: 'bg-yellow-100 text-yellow-800',
    [DriverStatus.ACTIVE]: 'bg-green-100 text-green-800',
    [DriverStatus.INACTIVE]: 'bg-red-100 text-red-800',
    [DriverStatus.DELETED]: 'bg-gray-100 text-gray-800',
};

export const DEFAULT_STATUS_CHIP_CLASS = 'bg-gray-100 text-gray-800';
